import { createReducer, Action, on } from '@ngrx/store';

import { SimilarParagraphActions } from './similar-paragraph.actions';
import { SimilarParagraphState } from './similar-paragraph.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';
import { DealActions } from '../deal/deal.actions';

export const initialState: SimilarParagraphState = {
  loading: false,
  sort: { active: 'score', direction: 'desc' },
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(SimilarParagraphActions.SearchSimilarParagraphs, (state, action) => ({
      ...state,
      loading: true,
      error: undefined,
      similarParagraphs: [],
      originalParagraph: action.searchText || state.originalParagraph,
    })),
    on(SimilarParagraphActions.SearchSimilarParagraphsSuccess, (state, action) => ({
      ...state,
      loading: false,
      similarParagraphs: action.list,
    })),
    on(SimilarParagraphActions.SearchSimilarParagraphsFail, (state, action) => ({
      ...state,
      loading: false,
      error: action.error,
    })),
    on(SimilarParagraphActions.SetSort, (state, action) => ({ ...state, sort: action.sort })),
    on(DealActions.LoadDealSuccess, (state, action) => {
      return {
        ...initialState,
      };
    })
  )
);

export function reducer(state: SimilarParagraphState | undefined, action: Action) {
  return featureReducer(state, action);
}
